let fishData = [
  {
    key: 2011,
    img: "fish/Pale_Chub_ACNH.png",
    name: "Pale Shub",
    price: 160,
  },
  {
    key: 2012,
    img: "fish/Crucian_Carp_ACNH.png",
    name: "Curcian Carp",
    price: 160,
  },
  {
    key: 2013,
    img: "fish/Bitterling_ACNH.png",
    name: "Bitterling",
    price: 900,
  },
  {
    key: 2014,
    img: "fish/Dace_ACNH.png",
    name: "Dace",
    price: 240,
  },
  {
    key: 2015,
    img: "fish/Carp_ACNH.png",
    name: "Carp",
    price: 300,
  },
  {
    key: 2016,
    img: "fish/Koi_ACNH.png",
    name: "Koi",
    price: 4000,
  },
  {
    key: 2017,
    img: "fish/Goldfish_ACNH.png",
    name: "Goldfish",
    price: 1300,
  },
  {
    key: 2018,
    img: "fish/Popeyed_Goldfish_ACNH.png",
    name: "Popeyed Goldfish",
    price: 1300,
  },
  {
    key: 2019,
    img: "fish/Ranchu_Goldfish_ACNH.png",
    name: "Ranchu Goldfish",
    price: 4500,
  },
  {
    key: 20110,
    img: "fish/Killifish_ACNH.png",
    name: "Killfish",
    price: 300,
  },
  {
    key: 20111,
    img: "fish/Crawfish_ACNH.png",
    name: "Crawfish",
    price: 200,
  },
  {
    key: 20112,
    img: "fish/Soft_Shelled_Turtle_ACNH.png",
    name: "Soft Shelled Turtle",
    price: 3750,
  },
  {
    key: 20113,
    img: "fish/Snapping_Turtle_ACNH.png",
    name: "Snapping Turtle",
    price: 5000,
  },
  {
    key: 20114,
    img: "fish/Tadpole_ACNH.png",
    name: "Tadpole",
    price: 100,
  },
  {
    key: 20115,
    img: "fish/Frog_ACNH.png",
    name: "Frog",
    price: 120,
  },
  {
    key: 20116,
    img: "fish/Freshwater_Goby_ACNH.png",
    name: "Freshwater Goby",
    price: 400,
  },
  {
    key: 20117,
    img: "fish/Loach_ACNH.png",
    name: "Loach",
    price: 400,
  },
  {
    key: 20118,
    img: "fish/Catfish_ACNH.png",
    name: "Catfish",
    price: 800,
  },
  {
    key: 20119,
    img: "fish/Giant_Snakehead_ACNH.png",
    name: "Giant Snakehead",
    price: 5500,
  },
  {
    key: 20120,
    img: "fish/Bluegill_ACNH.png",
    name: "Bluegill",
    price: 180,
  },
  {
    key: 20121,
    img: "fish/Yellow_Perch_ACNH.png",
    name: "Yellow Perch",
    price: 300,
  },
  {
    key: 20122,
    img: "fish/Black_Bass_ACNH.png",
    name: "Black Bass",
    price: 400,
  },
  {
    key: 20123,
    img: "fish/Tilapia_ACNH.png",
    name: "Tilapia",
    price: 800,
  },
  {
    key: 20124,
    img: "fish/Pike_ACNH.png",
    name: "Pike",
    price: 1800,
  },
  {
    key: 20125,
    img: "fish/Pond_Smelt_ACNH.png",
    name: "Pond Smelt",
    price: 500,
  },
  {
    key: 20126,
    img: "fish/Cherry_Salmon_ACNH.png",
    name: "Cherry Salmon",
    price: 1000,
  },
  {
    key: 20127,
    img: "fish/Sweetfish_ACNH.png",
    name: "Sweetfish",
    price: 900,
  },
  {
    key: 12938,
    img: "fish/Char_ACNH.png",
    name: "Char",
    price: 3800,
  },
  {
    key: 20128,
    img: "fish/Golden_Trout_ACNH.png",
    name: "Golden Trout",
    price: 15000,
  },
  {
    key: 20129,
    img: "fish/Stringfish_ACNH.png",
    name: "Stringfish",
    price: 15000,
  },
  {
    key: 20130,
    img: "fish/Salmon_ACNH.png",
    name: "Salmon",
    price: 700,
  },
  {
    key: 20131,
    img: "fish/King_Salmon_ACNH.png",
    name: "King Salmon",
    price: 1800,
  },
  {
    key: 20132,
    img: "fish/Mitten_Crab_ACNH.png",
    name: "Mitten Crab",
    price: 2000,
  },
  {
    key: 20133,
    img: "fish/Guppy_ACNH.png",
    name: "Guppy",
    price: 1300,
  },
  {
    key: 20134,
    img: "fish/Nibble_Fish_ACNH.png",
    name: "Nibble Fish",
    price: 1500,
  },
  {
    key: 20135,
    img: "fish/Angelfish_ACNH.png",
    name: "Angelfish",
    price: 3000,
  },
  {
    key: 20136,
    img: "fish/Betta_ACNH.png",
    name: "Betta",
    price: 2500,
  },
  {
    key: 20137,
    img: "fish/Neon_Tetra_ACNH.png",
    name: "Neon Tetra",
    price: 500,
  },
  {
    key: 20138,
    img: "fish/Rainbowfish_ACNH.png",
    name: "Rainbow Fish",
    price: 800,
  },
  {
    key: 20139,
    img: "fish/Piranha_ACNH.png",
    name: "Piranha",
    price: 2500,
  },
  {
    key: 20140,
    img: "fish/Arowana_ACNH.png",
    name: "Arowana",
    price: 10000,
  },
  {
    key: 20141,
    img: "fish/Dorado_ACNH.png",
    name: "Dorado",
    price: 15000,
  },
  {
    key: 20142,
    img: "fish/Gar_ACNH.png",
    name: "Gar",
    price: 6000,
  },
  {
    key: 20143,
    img: "fish/Arapaima_ACNH.png",
    name: "Arapaima",
    price: 10000,
  },
  {
    key: 20144,
    img: "fish/Saddled_Bichir_ACNH.png",
    name: "Saddled Bichir",
    price: 4000,
  },
  {
    key: 20145,
    img: "fish/Sturgeon_ACNH.png",
    name: "Sturgeon",
    price: 10000,
  },
  {
    key: 20146,
    img: "fish/Sea_Butterfly_ACNH.png",
    name: "Sea Butterfly",
    price: 1000,
  },
  {
    key: 20147,
    img: "fish/Seahorse_ACNH.png",
    name: "Seahorse",
    price: 1100,
  },
  {
    key: 20148,
    img: "fish/Clownfish_ACNH.png",
    name: "Clownfish",
    price: 650,
  },
  {
    key: 20149,
    img: "fish/Surgeonfish_ACNH.png",
    name: "Surgeon Fish",
    price: 1000,
  },
  {
    key: 20150,
    img: "fish/Butterfly_Fish_ACNH.png",
    name: "Butterfly Fish",
    price: 1000,
  },
  {
    key: 20151,
    img: "fish/Napoleonfish_ACNH.png",
    name: "Napoleon Fish",
    price: 10000,
  },
  {
    key: 20152,
    img: "fish/Zebra_Turkeyfish_ACNH.png",
    name: "Zebra Turkeyfish",
    price: 500,
  },
  {
    key: 20153,
    img: "fish/Blowfish_ACNH.png",
    name: "Blowfish",
    price: 5000,
  },
  {
    key: 20154,
    img: "fish/Puffer_Fish_ACNH.png",
    name: "Puffer Fish",
    price: 250,
  },
  {
    key: 20155,
    img: "fish/Anchovy_ACNH.png",
    name: "Anchovy",
    price: 200,
  },
  {
    key: 20156,
    img: "fish/Horse_Mackerel_ACNH.png",
    name: "Horse Macherel",
    price: 150,
  },
  {
    key: 20157,
    img: "fish/Barred_Knifejaw_ACNH.png",
    name: "Barred Knifejaw",
    price: 5000,
  },
  {
    key: 20158,
    img: "fish/Sea_Bass_ACNH.png",
    name: "Sea Bass",
    price: 400,
  },
  {
    key: 20159,
    img: "fish/Red_Snapper_ACNH.png",
    name: "Red Snapper",
    price: 3000,
  },
  {
    key: 20160,
    img: "fish/Dab_ACNH.png",
    name: "Dab",
    price: 300,
  },
  {
    key: 20161,
    img: "fish/Olive_Flounder_ACNH.png",
    name: "Olive Flounder",
    price: 800,
  },
  {
    key: 20162,
    img: "fish/Squid_ACNH.png",
    name: "Squid",
    price: 500,
  },
  {
    key: 20163,
    img: "fish/Moray_Eel_ACNH.png",
    name: "Moray Eel",
    price: 2000,
  },
  {
    key: 20164,
    img: "fish/Ribbon_Eel_ACNH.png",
    name: "Ribbon Eel",
    price: 600,
  },
  {
    key: 20165,
    img: "fish/Tuna_ACNH.png",
    name: "Tuna",
    price: 7000,
  },
  {
    key: 20166,
    img: "fish/Blue_Marlin_ACNH.png",
    name: "Blue Marlin",
    price: 10000,
  },
  {
    key: 20167,
    img: "fish/Giant_Trevally_ACNH.png",
    name: "Giant Trevally",
    price: 4500,
  },
  {
    key: 20168,
    img: "fish/Mahi_Mahi_ACNH.png",
    name: "Mahi Mahi",
    price: 6000,
  },
  {
    key: 20169,
    img: "fish/Ocean_Sunfish_ACNH.png",
    name: "Ocean Sunfish",
    price: 4000,
  },
  {
    key: 20170,
    img: "fish/Ray_ACNH.png",
    name: "Ray",
    price: 3000,
  },
  {
    key: 20171,
    img: "fish/Saw_Shark_ACNH.png",
    name: "Saw Shark",
    price: 12000,
  },
  {
    key: 20172,
    img: "fish/Hammerhead_Shark_ACNH.png",
    name: "Hammerhead Shark",
    price: 8000,
  },
  {
    key: 20173,
    img: "fish/Great_White_Shark_ACNH.png",
    name: "Great White Shark",
    price: 15000,
  },
  {
    key: 20174,
    img: "fish/Whale_Shark_ACNH.png",
    name: "Whale Shark",
    price: 13000,
  },
  {
    key: 20175,
    img: "fish/Suckerfish_ACNH.png",
    name: "Sucker Fish",
    price: 1500,
  },
  {
    key: 20176,
    img: "fish/Football_Fish_ACNH.png",
    name: "Football Fish",
    price: 2500,
  },
  {
    key: 20177,
    img: "fish/Oarfish_ACNH.png",
    name: "Oarfish",
    price: 9000,
  },
  {
    key: 20178,
    img: "fish/Barreleye_ACNH.png",
    name: "Barreleye",
    price: 15000,
  },
  {
    key: 20179,
    img: "fish/Coelacanth_ACNH.png",
    name: "Coelacanth",
    price: 15000,
  },
];

export default fishData;
